import { useIntl } from '@weenat/wintl'
import DelimitedFlex from 'app/src/kit/DelimitedFlex'
import { IconProps } from 'app/src/kit/Icon'
import Icons from 'app/src/kit/Icons'
import Text from 'app/src/kit/Text'
import { FlexProps } from 'app/src/kit/primitives/themeMappings/props'
import TextTooltip from 'app/src/kit/tooltips/TextTooltip'
import { useToggleFeature } from 'app/state'
import isNil from 'lodash-es/isNil'
import { ReactNode, memo } from 'react'
import { styled } from 'styled-components'

const Titles = styled(Flex)`
  flex: 1;
  align-items: center;

  gap: 4px;
  overflow: hidden;
`

interface PlotCardHeaderProps extends FlexProps {
  isFavorite?: boolean
  isFavoriteRequestLoading?: boolean
  name: string
  reverseGeocoding: string | null
  onFavoritePress?: IconProps['onPress']
  Icon: ReactNode
  onClose?: () => void
}

const DumbPlotCardHeader: FC<PlotCardHeaderProps> = ({
  name,
  reverseGeocoding,
  isFavoriteRequestLoading,
  isFavorite,
  onFavoritePress,
  Icon,
  onClose,
  ref: _notUsed,
  ...flexProps
}) => {
  const { t } = useIntl()
  const [{ on_nav_favorites }] = useToggleFeature()

  return (
    <DelimitedFlex $alignItems='center' $p='md' $gap='md' {...flexProps}>
      <Titles>
        <Flex $flexDirection='column' $minWidth={0} $flex={1}>
          <Text $flexed $fontWeight='bold' $ellipsis>
            {name}
          </Text>
          <Text $fontSize='sm' $color={'grayscale.700'} $ellipsis>
            {!isNil(reverseGeocoding)
              ? reverseGeocoding
              : t('models.device.unknown_location', { capitalize: true })}
          </Text>
        </Flex>
      </Titles>
      {onFavoritePress && !on_nav_favorites ? (
        <TextTooltip
          restMs={1000}
          content={t(`actions.${!isFavorite ? 'add_to_favorite' : 'remove_from_favorite'}`)}
        >
          <Icons.Star
            $p='md'
            $size='lg'
            $isLoading={isFavoriteRequestLoading}
            onPress={onFavoritePress}
            $color={isFavorite ? 'primary.500' : 'grayscale.300'}
          />
        </TextTooltip>
      ) : null}
      {onClose ? (
        <TextTooltip restMs={1000} content={t(`actions.close`)}>
          <Icons.Close $backgroundColor={'grayscale.100'} $p='md' $size='lg' onPress={onClose} />
        </TextTooltip>
      ) : null}
    </DelimitedFlex>
  )
}

export const PlotCardHeader = memo(DumbPlotCardHeader)
